// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606290200/js/" + chunkId + "." + {"44":"7ae14762","225":"9a6021cb","481":"de7aa302","486":"f35d28c7","770":"795ef4a4"}[chunkId] + ".0.7037199325029279.chunk.js";
};